import { useCallback, useRef } from 'react';
import { TRUNCATION_TOOLTIP_ATTR_NAME, UPDATE_TOOLTIP_EVENT_TYPE } from '../useTruncationTooltip';
const keyboardTooltipConfigMap = new Map();
export const useKeyboardTooltip = config => {
  const prevElementRef = useRef(null);
  const setRef = useCallback(element => {
    if (element === null) {
      if (prevElementRef.current) {
        keyboardTooltipConfigMap.delete(prevElementRef.current);
      }
    } else {
      keyboardTooltipConfigMap.set(element, config);
    }
    if (element && element === document.activeElement) {
      // If the element has the focus, update a dummy attribute to trigger the MutationObserver
      // so that the keyboard tooltip is updated
      element.setAttribute('data-keyboard-tooltip', 'dummyData');
      element.removeAttribute('data-keyboard-tooltip');
    }
    prevElementRef.current = element;
  }, [config]);
  return setRef;
};
const getTitleAttribute = element => {
  if (!element) return null;
  const keyboardTooltip = element.getAttribute('data-keyboard-tooltip');
  if (keyboardTooltip) return keyboardTooltip;
  if (element.getAttribute(TRUNCATION_TOOLTIP_ATTR_NAME)) {
    // let useTruncationTooltip update the title first
    element.dispatchEvent(new Event(UPDATE_TOOLTIP_EVENT_TYPE, {
      bubbles: false
    }));
  }
  return element.getAttribute('title');
};
export const getKeyboardTooltip = (element = document.activeElement) => {
  const keyboardTooltipConfig = element ? keyboardTooltipConfigMap.get(element) : undefined;
  const tooltips = [];

  // When startElementRef is provided, use it even when it points to `null`
  const startElement = keyboardTooltipConfig?.startElementRef === undefined ? element : keyboardTooltipConfig.startElementRef.current;
  if (keyboardTooltipConfig?.tooltip) {
    tooltips.push(keyboardTooltipConfig.tooltip);
  } else {
    const tooltip = keyboardTooltipConfig?.getTooltip?.();
    if (tooltip) {
      tooltips.push(tooltip);
    } else {
      const title = getTitleAttribute(startElement);
      if (title) {
        tooltips.push(title);
      }
    }
  }
  const addTooltips = elements => {
    for (const element of elements?.values?.() ?? []) {
      const title = getTitleAttribute(element);
      if (title) {
        tooltips.push(title);
      }
    }
  };
  if (keyboardTooltipConfig?.traverseChildren) {
    addTooltips(startElement?.querySelectorAll(`[title]:not([title='']),[${TRUNCATION_TOOLTIP_ATTR_NAME}]`));
  }
  for (const selector of keyboardTooltipConfig?.selectors ?? []) {
    addTooltips((selector.startsWith('.') ? startElement : document)?.querySelectorAll(selector));
  }
  return tooltips.join('\n\n');
};
//# sourceMappingURL=useKeyboardTooltip.js.map